


<template>
   
      <div class="py-1 ">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header pb-0">
             
              <div class="align-items-center">
                <p class="mb-0 text-lg text-center text-black">
                   VAT Refund Application for Tourists </p>
                <p class="mb-0 text-md text-left text-black">
                Receipt No.  :  {{ receiptStore.receiptsCode }}
                </p>
                 <p class="mb-0 text-md text-left text-black">
                Store No. :   {{ receiptStore.storeNumber }}
                </p>
              </div>
            </div>
            <div class="card-body mt-1">
               <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="full_name" class="form-control-label">
                          Name 
                    </label>
                    <InputText
                     v-model="full_name" type="text"  
                     icon="fa fa-user" iconDir="left" 
                     :class="{ 'is-invalid': fullNameErrorKey }"
                     placeholder="Name"
                      @keydown="blockNonEnglishAndSpcChar"
                      @input="e => filterNonEnglish(e, full_name)"
                      @paste.prevent
                      @copy.prevent
               
 
                     />
                     <small v-if="fullNameErrorKey" class="text-danger">Please enter Name </small>
                  </div>
                </div>


                 <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="last_name" class="form-control-label">
                         Surname
                    </label>
                    <InputText
                     v-model="last_name" type="text"  
                     icon="fa fa-user" iconDir="left" 
                     :class="{ 'is-invalid': lastNameErrorKey }"
                     placeholder="Surname"
                      @keydown="blockNonEnglishAndSpcChar"
                      @input="e => filterNonEnglish(e, last_name)"
                      @paste.prevent
                      @copy.prevent
              
                     />
                     <small v-if="lastNameErrorKey" class="text-danger">Please enter Surname </small>
                  </div>
                </div>

               <div class="row mt-3" >
                  <div class="col-md-12">
                      <label for="country" class="form-control-label">
                      
                    Country
                    
                    </label>
                   <SelectSearch
                    v-model="country"
                    :fetchFunc="fetchCountryList"
                    :icon="require('@/assets/img/icons/pages/icon_country.png')"
                    :error="!!countryErrorKey"
                    :class="{ 'is-invalid': countryError }"
                    labelKey="name_en"
                    idKey="id"
                    placeholder="Country"
                    @keydown="blockNonEnglishNumberV2"
                    @paste.prevent
                    @copy.prevent
                  />
                   <small v-if="countryErrorKey" class="text-danger">Please enter Country</small>
                  </div>
                </div>

            
                  <!-- <div class="row mt-3" hidden>
                  <div class="col-md-12">
                      <label for="country" class="form-control-label">
                      
                    Nationality
                    
                    </label>
                   <SelectSearch
                    v-model="nationality_name"
                    :fetchFunc="fetchNationalityList"
                     :error="!!NationalityNameErrorKey"
                    :class="{ 'is-invalid': NationalityNameError }"
                     :icon="require('@/assets/img/icons/pages/icon_country.png')"
                    labelKey="national_name"
                    idKey="id"
                    placeholder="Nationality"
                  />
                   <small v-if="NationalityNameErrorKey" class="text-danger">Please enter Nationality</small>
                  </div>
                </div> -->

                <div class="row mt-3">
                  <div class="col-md-12">
                      <label for="passport_no" class="form-control-label">
                    
                    Passport No.
                    </label>
                    <InputText v-model="passport_no"
                     type="text"
                     :class="{ 'is-invalid': PassportNoError }"
                     placeholder="Passport No."
                     icon="fa fa-id-card-o"
                     @keydown="blockEngNumberOnly"
                      @input="sanitizeEngNumber"
                      @paste.prevent
                      @copy.prevent
                     iconDir="left"/>
                     <small v-if="PassportNoError" class="text-danger">Please enter Passport No.</small>
                  </div>
                </div>


                <div class="row mt-3" hidden>
                  <div class="col-md-12">
                      <label for="arrivalDate" class="form-control-label">
                    
                    Arrival Date
                    </label>
                    <InputDatepicker v-model="arrivalDate"  :class="{ 'is-invalid': ArrivalDateErrorKey }"  placeholder="Arrival Date" />
                     <small v-if="ArrivalDateErrorKey" class="text-danger">Please verify the Arrival date</small>
                  </div>
                </div>

                <div class="row mt-3" hidden>
                  <div class="col-md-12">
                      <label for="departureDate" class="form-control-label">
                    
                    Departure Date
                    </label>
                   <InputDatepicker v-model="departureDate" :class="{ 'is-invalid': DepartureDateErrorKey }"  placeholder="Departure Date" />
                     <small v-if="DepartureDateErrorKey" class="text-danger">Please verify the Departure date </small>
                  </div>
                </div>



                <div class="row mt-3" hidden> 
                  <div class="col-md-12">
                      <label for="customer_address" class="form-control-label">
                      
                         Permanent/Mailing Address 1
                    
                    </label>
                   <textarea
                      id="customer_address"
                      v-model="customer_address"
                      :class="{ 'is-invalid': address1Error }"
                      class="form-control"
                      rows="3"
                      placeholder="Permanent/Mailing Address"
                    ></textarea>
                     <small v-if="address1Error" class="text-danger">Please enter Permanent/Mailing Address 1</small>
                  </div>
                </div>


                <div class="row mt-3" hidden>
                  <div class="col-md-12">
                      <label for="customer_address_2" class="form-control-label">
                        Permanent/Mailing Address 2
                    </label>
                     <textarea
                      id="customer_address_2"
                      v-model="customer_address_2"
                      class="form-control"
                      rows="3"
                      placeholder="Permanent/Mailing Address 2"
                    ></textarea>
                  </div>
                </div>

                <div class="row mt-2" hidden>
                  <div class="col-md-12">
                     <label for="InvoicePostCode" class="form-control-label">
                    PostCode
                    </label>
                      <InputText v-model="post_code" iconDir="left" maxlength="20"
                      
                       :class="{ 'is-invalid': postCodeError }">
                        <template #icon>
                          <img :src="IconPostCode" alt="Thailand Flag" style="width: 15px; height: auto;" />
                        </template>
                      </InputText>
                         <small v-if="postCodeError" class="text-danger">Please enter Post Code</small>

                  </div>
                </div>

                 <div class="row mt-2" hidden>
                  <div class="col-md-12">
                     <label for="CityName" class="form-control-label">
                   City
                    </label>
                      <InputText v-model="city_name" iconDir="left"
                       :class="{ 'is-invalid': CityNameErrorKey }">
                        <template #icon>
                          <img :src="IconCity" alt="Thailand Flag" style="width: 15px; height: auto;" />
                        </template>
                      </InputText>
                         <small v-if="CityNameErrorKey" class="text-danger">Please enter City</small>

                  </div>
                </div>

                


                <div class="row mt-2">
                  <div class="col-md-12">
                     <label for="email" class="form-control-label">
                   Email
                    </label>
                      <InputText v-model="email" 
                       :class="{ 'is-invalid': emailErrorKey }"
                        placeholder="Email"
                        @keydown="blockEmailAllSpecial"
                        @input="sanitizeEmailAllSpecial"
                        @paste.prevent
                        @copy.prevent
                        iconDir="left">

                         <!-- @keydown="blockEmailChars"
                          @input="sanitizeEmailChars" -->
                        
                        <template #icon>
                          <img :src="IconEmail" alt="Thailand Flag" style="width: 15px; height: auto;" />
                        </template>
                      </InputText>
                         <small v-if="emailErrorKey" class="text-danger">Please enter Email</small>

                  </div>
                </div>

                 <div class="row mt-3" hidden>
                  <div class="col-md-12">
                      <label for="phone_number" class="form-control-label">
                       Mobile Phone Number
                    
                    </label>
                   <InputText v-model="phone_number" type="text"
                    :class="{ 'is-invalid': phoneNumberError }"
                     placeholder=""
                      maxlength="15"
                      @input="limitPhoneNumberLength"
                      @paste.prevent
                      @copy.prevent
                     icon="fa fa-id-card-o"
                     iconDir="left"/>
                        <small v-if="phoneNumberError" class="text-danger">Please enter Phone Number</small>
                  </div>
                </div>
                <br>
            <div class="custom-checkbox-wrapper">
              <input 
                type="checkbox"
                id="acceptTerms"
                v-model="acceptTerms"
                class="custom-checkbox"
                :class="{ 'invalid': termsErrorKey }"
              />
              <label for="acceptTerms" class="checkbox-label">
                <!-- <span style="font-size:12px;">I have read and agree to the applicable Terms & Condition</span> -->
               <span style="font-size:12px;"><a style="font-weight:400;color: #64748B;">I have read and agree to the applicable </a> <a target="_blank" href="https://pacifica.co.th/privacy-policy/">Terms & Condition</a></span>

              </label>
            </div>
            <span class="text-danger" style="font-size:12px;">
               The company reserves the right not to re-issue VAT refund or make retroactive correction in any case.
            </span>


            
                              
              <!-- <hr class="horizontal dark" /> -->
           
              <div class="row mb-5 mt-4">
                  <div class="col-md-6">
                      <GlobalButtonPrv @click="handleClickClear">
                      Clear <i class="fa fa-trash" aria-hidden="true"  style="font-size: 18px; margin-left:5px;"></i>

                      </GlobalButtonPrv>
                  </div>
                  <div class="col-md-6">
                    <GlobalButtonNext @click="handleClickNextPage">
                      Next  <i class="fa fa-paper-plane" aria-hidden="true" style="font-size: 18px; margin-left:5px;"></i>
                    </GlobalButtonNext>
                </div>
              </div>
               
            </div>
          </div>
        </div>
        <div class="col-md-4 mb-5">
        </div>
      </div>
    </div>

     


</template>







<script setup>
import { fetchCountryList } from '@/service-api/request-api-evrt';
import GlobalButtonNext from "@/components/global/GlobalButtonPrimary.vue";
import GlobalButtonPrv from "@/components/global/GlobalButtonGrey.vue";
import InputText from "@/components/global/InputText.vue";
import SelectSearch from "@/components/global/SelectSearch.vue";
import InputDatepicker from "@/components/global/InputDatePicker.vue";
import { useReceiptStoreEvrt } from '@/store/useReceiptStoreEvrt';
import { onMounted,ref ,watch } from "vue";
import { computed} from "vue";
import IconPostCode from '@/assets/img/icons/pages/icon_postcode.svg';
import IconCity from '@/assets/img/icons/pages/icon_city.png';
import IconCountry from '@/assets/img/icons/pages/icon_country.png';
import IconEmail from '@/assets/img/icons/pages/icon_email.png';
import IconPhone from '@/assets/img/icons/pages/icon_phone.png';
import messages from '@/locales/messages';
import { useLanguageStore } from '@/store/useLanguageStore';
const languageStore = useLanguageStore();
const receiptStore = useReceiptStoreEvrt();
const currentMessages = computed(() => messages[languageStore.selectedLanguage]);
const arrivalDate = ref(receiptStore.arrivalDate || null);
const departureDate = ref(receiptStore.departureDate || null);

  
const emit = defineEmits(['next', 'prev', 'sendotp', 'invoice', 'preview', 'submission']);
// const handleClickNextPage = () => {
//   emit('preview'); 
// };

//  Default selected type
const selectedType = ref('person');


const store_number = ref('');
const country = ref(null); 
const customer_address_2 = ref('');

const full_name = ref('');
const fullNameErrorKey = ref('');
const fullNameError = computed(() => {
  return fullNameErrorKey.value ? currentMessages.value[fullNameErrorKey.value] : '';
});

const last_name = ref('');
const lastNameErrorKey = ref('');
const lastNameError = computed(() => {
  return lastNameErrorKey.value ? currentMessages.value[lastNameErrorKey.value] : '';
});

const passport_no = ref('');
const PassportNoErrorKey = ref('');
const PassportNoError = computed(() => {
  return PassportNoErrorKey.value ? currentMessages.value[PassportNoErrorKey.value] : '';
});

const post_code = ref('');
const postCodeErrorKey = ref('');
const postCodeError = computed(() => {
  return postCodeErrorKey.value ? currentMessages.value[postCodeErrorKey.value] : '';
});


const customer_address = ref('');
const address1ErrorKey = ref('');
const address1Error = computed(() => {
  return address1ErrorKey.value ? currentMessages.value[address1ErrorKey.value] : '';
});

const phone_number = ref('');
const phoneNumberErrorKey = ref('');
const phoneNumberError = computed(() => {
  return phoneNumberErrorKey.value ? currentMessages.value[phoneNumberErrorKey.value] : '';
});




const ArrivalDateErrorKey = ref('');
const ArrivalDateError = computed(() => {
  return ArrivalDateErrorKey.value ? currentMessages.value[ArrivalDateErrorKey.value] : '';
});

const DepartureDateErrorKey = ref('');
const DepartureDateError = computed(() => {
  return DepartureDateErrorKey.value ? currentMessages.value[DepartureDateErrorKey.value] : '';
});

// const nationality_name = ref('');
// const NationalityNameErrorKey = ref('');
// const NationalityNameError = computed(() => {
//   return NationalityNameErrorKey.value ? currentMessages.value[NationalityNameErrorKey.value] : '';
// });

const email = ref('');
const emailErrorKey = ref('');
const EmailError = computed(() => {
  return emailErrorKey.value ? currentMessages.value[emailErrorKey.value] : '';
});
const acceptTerms = ref(false);
const termsErrorKey = ref('');
// const termsError = computed(() => {
//   return termsErrorKey.value ? currentMessages.value[termsErrorKey.value] : '';
// });
const city_name = ref('');
const countryErrorKey = ref('');
const countryError = computed(() => {
  return countryErrorKey.value ? currentMessages.value[countryErrorKey.value] : '';
});

const CityNameErrorKey = ref('');
const CityNameError = computed(() => {
  return CityNameErrorKey.value ? currentMessages.value[CityNameErrorKey.value] : '';
});
///



const validateForm = () => {
  let valid = true;

  fullNameErrorKey.value = '';
  lastNameErrorKey.value = '';
  PassportNoErrorKey.value = '';
  postCodeErrorKey.value = '';
  address1ErrorKey.value = '';
  phoneNumberErrorKey.value = '';

  //NationalityNameErrorKey.value = '';
  ArrivalDateErrorKey.value = '';
  DepartureDateErrorKey.value = '';
  CityNameErrorKey.value = '';
  emailErrorKey.value = '';

  if (!country.value || 
      (typeof country.value === 'object' && !country.value.name_en) || 
      (typeof country.value === 'string' && country.value.trim() === '')
  ) {
      countryErrorKey.value = 'ValidationRequiredCountry';
      valid = false;
  } else {
      countryErrorKey.value = '';
  }



  if (!full_name.value.trim() || !isEnglishOnly(full_name.value)) {
    fullNameErrorKey.value = 'ValidationEnglishOnly';
    valid = false;
  }

  if (!last_name.value.trim() || !isEnglishOnly(last_name.value)) {
    lastNameErrorKey.value = 'ValidationEnglishOnly';
    valid = false;
  }

  if (!passport_no.value.trim()) {
    PassportNoErrorKey.value = 'ValidationRequiredTaxID';
    valid = false;
  } else {
    PassportNoErrorKey.value = '';
  }


  
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email.value.trim() || !emailPattern.test(email.value)) {
    emailErrorKey.value = 'invalid';
    valid = false;
  }


    if (!acceptTerms.value) {
      termsErrorKey.value = 'InvoiceTermAndCorditionNoticeRecheck';
      valid = false;
    } else {
      termsErrorKey.value = '';
    }


  return valid;
};


const handleClickNextPage = () => {
  if (!validateForm()) return;

   receiptStore.$patch({
     receiptsCode: receiptStore.receiptsCode, 
      storeNumber: receiptStore.storeNumber,
      selectedType: selectedType.value,
      full_name: full_name.value, // 
      last_name: last_name.value, // 
      passport_no: passport_no.value, //
      store_number: store_number.value, 
      country: country.value, // 
      post_code: post_code.value, //
      customer_address: customer_address.value, //
      customer_address_2: customer_address_2.value, //
      arrivalDate: arrivalDate.value, //
      departureDate: departureDate.value, //
      city_name: city_name.value, //
    //  nationality_name: nationality_name.value, //
      email: email.value, //
      phone_number: phone_number.value, // 
  });

  emit('preview');
};
// const limitTaxIDLength = (e) => {
//   passport_no.value = e.target.value.replace(/\D/g, '').slice(0, 13);
// };

const limitPhoneNumberLength = (e) => {
  phone_number.value = e.target.value.replace(/\D/g, '').slice(0, 15);
};

const blockNonEnglishNumber = (event) => {
  const allowedKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'Tab', 'Home', 'End'
  ];

  if (allowedKeys.includes(event.key)) return;

  if (!/^[A-Za-z0-9]$/.test(event.key)) {
    event.preventDefault();
  }
};

// กัน paste / drag / autofill
const sanitizeEnglishNumber = (e) => {
  full_name.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
};


// อนุญาต key ที่จำเป็น
const blockEmailChars = (event) => {
  const controlKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'Tab', 'Home', 'End'
  ];

  if (controlKeys.includes(event.key)) return;

  // อังกฤษ + ตัวเลข + email special
  if (!/^[A-Za-z0-9@._+\-]$/.test(event.key)) {
    event.preventDefault();
  }
};

// กัน paste / autofill
const sanitizeEmailChars = (e) => {
  email.value = e.target.value.replace(/[^A-Za-z0-9@._+\-]/g, '');
};

///////


const blockNonEnglishAndSpcCharV1 = (event) => {
  const allowedKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'Tab', 'Home', 'End'
  ];

  if (allowedKeys.includes(event.key)) return;

  // A-Z a-z + ASCII special characters + space
  if (!/^[A-Za-z !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]$/.test(event.key)) {
    event.preventDefault();
  }
};


const blockNonEnglishAndSpcChar = (event) => {
  const allowedKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'Tab', 'Home', 'End'
  ];
  if (allowedKeys.includes(event.key)) return;

  if (!/^[A-Za-z .'-]$/.test(event.key)) {
    event.preventDefault();
  }
};


const filterNonEnglish = (event, modelRef) => {
  // แปลงค่าที่พิมพ์เป็น NFKD (แยก diacritics)
  let val = event.target.value.normalize('NFKD');
  // ลบ accent marks
  val = val.replace(/[\u0300-\u036f]/g, '');
  // ลบตัวอักษรที่ไม่ใช่ A-Z, a-z, space, dot, dash, apostrophe
  val = val.replace(/[^A-Za-z .'-]/g, '');

  // อัปเดต input field
  event.target.value = val;

  // อัปเดต v-model
  if (modelRef && typeof modelRef === 'object' && 'value' in modelRef) {
    modelRef.value = val;
  }
};





// function blockNonEnglishNumberV2(event) {
//   // ปุ่มควบคุมที่อนุญาต
//   const allowedKeys = [
//     'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
//     'Tab', 'Home', 'End'
//   ];


//   if (allowedKeys.includes(event.key)) return;

//   // อนุญาตเฉพาะ A-Z, a-z, 0-9
//   if (!/^[A-Za-z0-9]$/.test(event.key)) {
//     event.preventDefault();
//   }
// }


const blockEngNumberOnly = (event) => {
  const allowedKeys = [
    'Backspace','Delete','ArrowLeft','ArrowRight',
    'Tab','Home','End'
  ];
  if (allowedKeys.includes(event.key)) return;

  // ENG + Number เท่านั้น
  if (!/^[A-Za-z0-9]$/.test(event.key)) {
    event.preventDefault();
  }
};
const sanitizeEngNumber = (e) => {
  passport_no.value = e.target.value.replace(/[^A-Za-z0-9]/g, '');
};


const blockEmailAllSpecial = (event) => {
  const controlKeys = [
    'Backspace','Delete','ArrowLeft','ArrowRight',
    'Tab','Home','End'
  ];
  if (controlKeys.includes(event.key)) return;

  // ENG + Number + special character (ทั้งหมด)
  // ป้องกันภาษาไทยและ unicode
  if (!/^[\x21-\x7E]$/.test(event.key)) {
    event.preventDefault();
  }
};


const sanitizeEmailAllSpecial = (e) => {
  email.value = e.target.value.replace(/[^\x21-\x7E]/g, '');
};

const blockNonEnglishNumberCountry = (event) => {
  const allowedKeys = [
    'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight',
    'Tab', 'Home', 'End'
  ];

  if (allowedKeys.includes(event.key)) return;

  if (!/^[A-Za-z0-9]$/.test(event.key)) {
    event.preventDefault();
  }
};


const handleClickClear = () => {
  // ล้างค่า fields ทั้งหมด
  full_name.value = '';
  last_name.value = '';
  //nationality_name.value = null;
  passport_no.value = '';
  store_number.value = '';
  arrivalDate.value = null;
  departureDate.value = null;
  customer_address.value = '';
  customer_address_2.value = '';
  post_code.value = '';
  city_name.value = '';
  country.value = null;
  email.value = '';
  phone_number.value = '';
  acceptTerms.value = false;

  // ล้าง error messages ด้วย
  fullNameErrorKey.value = '';
  lastNameErrorKey.value = '';
  PassportNoErrorKey.value = '';
  postCodeErrorKey.value = '';
  address1ErrorKey.value = '';
  phoneNumberErrorKey.value = '';
  //NationalityNameErrorKey.value = '';
  ArrivalDateErrorKey.value = '';
  DepartureDateErrorKey.value = '';
  CityNameErrorKey.value = '';
  emailErrorKey.value = '';
  countryErrorKey.value = '';
  termsErrorKey.value = '';
};


const isEnglishOnly = (value) => {
  if (!value) return true;
  const normalized = value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  return /^[A-Za-z .'-]+$/.test(normalized);
};




onMounted(() => {
  // โหลดข้อมูลจาก store --> input fields
  selectedType.value = receiptStore.selectedType || 'person';
  full_name.value = receiptStore.full_name || ''; //
  last_name.value = receiptStore.last_name || ''; //
  //nationality_name.value  = receiptStore.nationality_name  || '', // 
  passport_no.value = receiptStore.passport_no || ''; //
  store_number.value = receiptStore.store_number || '';

  arrivalDate.value = receiptStore.arrivalDate || null;
  departureDate.value = receiptStore.departureDate || null;


  customer_address.value = receiptStore.customer_address || ''; // 
  customer_address_2.value = receiptStore.customer_address_2 || ''; // 

  post_code.value = receiptStore.post_code || ''; //
  city_name.value = receiptStore.city_name || ''; //

  country.value = receiptStore.country || ''; //
  email.value = receiptStore.email || ''; // 
  phone_number.value = receiptStore.phone_number || ''; // 
   

  //console.log('arrivalDate initial:', arrivalDate.value);
  //console.log('departureDate initial:', departureDate.value);
});


watch(arrivalDate, (newVal) => {
  receiptStore.arrivalDate = newVal;
});

watch(departureDate, (newVal) => {
  receiptStore.departureDate = newVal;
});

watch(full_name, (val) => {
  full_name.value = val.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Za-z .'-]/g, '');
});

watch(last_name, (val) => {
  last_name.value = val.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Za-z .'-]/g, '');
});


</script>
<style scoped>
.radio-focused {
  border-color: orange !important;
  border-width: 2px;
  background-color: #ffffff;
}

.box-boder{
  border-radius: 10px!important;
}
.custom-radio-label {
  
    margin-bottom: 0;
}

.input-border{
    
    border-radius: 10px!important;
  }

.form-check-input.is-invalid {
  border: 2px solid #dc3545 !important;
  box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.25);
  outline: none;
}

.custom-checkbox-wrapper {
  display: flex;
  align-items: center; 
  gap: 8px;          
  margin-top: 10px;
}

.custom-checkbox {
  width: 18px;
  height: 18px;
  appearance: none;
  border: 2px solid #ccc;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
}

.custom-checkbox:checked {
  background-color: #000000;
  border-color: #000000;
}

.custom-checkbox.invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 2px rgba(220, 53, 69, 0.25);
}

.custom-checkbox::after {
  content: '✔';
  color: white;
  font-size: 12px;
  position: absolute;
  top: -2px;
  left: 2px;
  display: none;
}

.custom-checkbox:checked::after {
  display: block;
}

.checkbox-label {
  margin: 0;
  line-height: 1.4;
  cursor: pointer;
}
.form-control:disabled{
  background-color: white!important;
}

.form-control.input-border.mb-0.form-control-default{
   background-color: white!important;
}
.input-icon-wrapper {
width:100%;

}

.is-invalid {
  border: 1.5px solid #dc3545 !important;
  box-shadow: 0 0 0 0.15rem rgba(220, 53, 69, 0.25);
}


</style>

